import styled from '@emotion/styled';
import { Box } from '@updater/ui-uds';

export const Container = styled(Box)`
  border: 1px solid #ccc;
  max-width: 640px;
  margin: 0 auto;
  border-radius: ${({ theme }) => theme.radii.xl};
`;
